export function performMobileShare(onDone, url) {
  addWindowFocusListener(onDone)
  navigator.share({url, title: 'Web Hangman'})
    .then(() => onDone())
    .catch(() => onDone())
}

/*
 * https://bugs.chromium.org/p/chromium/issues/detail?id=636274
 * If the share promise is not resolved or rejected when focus is returned to
 * the window, then reject it after a 100ms delay.
 */
function addWindowFocusListener(onDone) {
  const cancel = () => setTimeout(() => {
    window.removeEventListener('focus', cancel)
    onDone()
  }, 100)

  window.addEventListener('focus', cancel)
}